import React from 'react';
import classNames from 'classnames';
import cls from '../../../../TemporaryConmonents/Gant/components/UI/Modal/Modal.module.css';

export const ImageModal = ({ onHideModal, children, zIndex = null, classes }) => {
    return (
        <>
            <div className={classNames(cls.customModal, { [cls.zIndex]: zIndex })}>
                <div className={classNames(cls.customModalOverlay, [classes])}>
                    <div className={classNames(cls.customModalContent)}>{children}</div>
                </div>
            </div>
        </>
    );
};
